module.exports = __webpack_public_path__ + "img/seo.456091ea.png";